import {createFeatureSelector, createSelector} from "@ngrx/store";
import {SelectorUtil} from "@app-web-central/web/shared/utils";
import {usersConfigFeatureKey, UsersConfigState} from "./users-config.reducer";

export const getUsersConfigState = createFeatureSelector<UsersConfigState>(usersConfigFeatureKey);

export const getUsersConfig = createSelector(getUsersConfigState, (state) => state.data);
export const getUsersConfigLoading = createSelector(getUsersConfigState, SelectorUtil.isLoading);
